// NOTE(jj): MessageSeverity type values should mirror the monolith Severity type (app/types/monolith/cart.ts).
// Do not replace this with the monolith type directly — this is the canonical app-level
// severity type and is the single source of truth within the app.
//
// See app/components/Messages/types.test.ts for enforcement.
export enum MessageSeverity {
  Error = 'error',
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
}

export enum MessageType {
  DiscountShipping = 'DISCOUNT_SHIPPING',
  DiscountSitewide = 'DISCOUNT_SITEWIDE',
  DiscountVolume = 'DISCOUNT_VOLUME',
  ExpiredProductRemoval = 'EXPIRED_PRODUCT_REMOVAL',
  FlatRateShippingApplied = 'FLAT_RATE_SHIPPING_APPLIED',
  FreeShippingOnProductApplied = 'FREE_SHIPPING_ON_PRODUCT_APPLIED',
  NonsaleableProductRemoval = 'NONSALEABLE_PRODUCT_REMOVAL',
  ProductWarning = 'PRODUCT_WARNING',
}

export interface Message {
  severity: MessageSeverity;
  type?: MessageType;
  actionUrl?: string;
  applied?: boolean;
  productName?: string;
  text?: string;
  itemId?: string;
}
